<div
    [formGroup]="form"
>
    Select Applicant field
    <select
        class="form-control"
        formControlName="applicantExternalDataField"
        name="applicantExternalDataField"
        (change)="handleChanges()"
        [(ngModel)]="sourceConfig.selectedOption"
    >
        <option
            *ngFor="let adOption of sourceConfig.options"
            [ngValue]="adOption"
        >
            {{ adOption.label }}
        </option>
    </select>   
</div>
